import angular from 'angular';

import AutofocusDirective from './autofocus.directive';

const AutofocusModule = angular
    .module('control-room.commons.basic.directives.autofocus', [])
    .directive('crAutofocus', AutofocusDirective.directiveFactory);

export default AutofocusModule;
